import { z } from 'zod';
// Un tirage unique fait du taux de citation un tirage au sort ; au-delà de 5 la
// facture monte plus vite que la précision.
export const AEO_MAX_SAMPLES = 5;
export const AEO_MIN_SAMPLES = 1;
// Appels simultanés au moteur. Rien n'interdit de tout lancer d'un coup : le
// plafond réel est le débit autorisé par le compte OpenAI, que seul l'usage
// révèle. Les dépassements sont réessayés, et le compteur de tirages perdus
// affiché après chaque run dit s'il faut redescendre.
export const AEO_MAX_CONCURRENCY = 45;
export const AEO_MIN_CONCURRENCY = 1;
export const createAeoPromptSchema = z.object({
    // Absent = groupe « Autres » dans le tableau de bord
    text: z.string().trim().min(1),
    topic: z.string().trim().optional(),
});
export const updateAeoPromptSchema = z.object({
    isActive: z.boolean().optional(),
    text: z.string().trim().min(1).optional(),
    topic: z.string().trim().optional(),
});
export const createAeoCompetitorSchema = z.object({
    name: z.string().trim().min(1),
    // Graphies alternatives rencontrées dans les réponses des moteurs
    aliases: z.array(z.string().trim().min(1)).default([]),
});
export const updateAeoSettingsSchema = z.object({
    brandName: z.string().trim().min(1).optional(),
    // Peut être vidée : une fiche fausse est pire qu'une fiche absente.
    agencyProfile: z.string().trim().optional(),
    // La virgule est interdite parce qu'elle est le séparateur de stockage : la
    // liste tient sur une ligne d'AppSetting. Un alias qui en contient repartirait
    // en deux à la relecture, et l'écran afficherait un alias que personne n'a
    // saisi. Refusé à l'entrée plutôt que corrigé en silence.
    brandAliases: z
        .array(z.string().trim().min(1).refine((alias) => !alias.includes(','), {
        message: 'Un alias ne peut pas contenir de virgule',
    }))
        .optional(),
    concurrency: z.number().int().min(AEO_MIN_CONCURRENCY).max(AEO_MAX_CONCURRENCY).optional(),
    samples: z.number().int().min(AEO_MIN_SAMPLES).max(AEO_MAX_SAMPLES).optional(),
});
